import { BaseSeriesSpecTransformer } from "../base";

export class BoxPlotSeriesSpecTransformer extends BaseSeriesSpecTransformer {
    _transformLabelSpec(spec) {
        this._addMarkLabelSpec(spec, "boxPlot");
    }
}
//# sourceMappingURL=box-plot-transformer.js.map
